var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100px"}},[_c('a-progress',{attrs:{"percent":_vm.percent.percent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }